/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { ApplicationSharing } from './application-sharing';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';

/**
 * (tsType: DataModuleWithRelations, schemaOptions: { includeRelations: true })
 */
export class DataModuleWithRelations {
  creationInfo?: ActionInfo;
  description?: null | NullableLocalizedValue;
  icon: null | Icon;
  id?: string;
  isImplicit: boolean;
  name: LocalizedValue;
  normalizedName: string;
  sharing: ApplicationSharing;
  specificationVersion: number;
  updateInfo?: ActionInfo;
}
